import { render, staticRenderFns } from "./RecordingsCleaner.vue?vue&type=template&id=1d14819c&scoped=true&"
import script from "./RecordingsCleaner.vue?vue&type=script&lang=js&"
export * from "./RecordingsCleaner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d14819c",
  null
  
)

export default component.exports